// extracted by mini-css-extract-plugin
module.exports = {"FaqPage":"styles_FaqPage__iATK7"};